<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title moduleIdentifier="shopee" :title="$t('shopee.account.label')">
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !shopeeAccount.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': shopeeAccount.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>
      <div class="l-row vertical-flex">
        <div class="l-col-3@md img-account">
          <img v-if="shopeeAccount.logo" :src="shopeeAccount.logo"/>
          <i v-if="!shopeeAccount.logo" class="icon-image2 no-photo"/>
        </div>
        <div class="l-col-9@md">
          <panel title="Dados da conta">
            <span class="ds-block"><strong>Nome:</strong> {{ shopeeAccount.shopName | attribute }}</span>
            <div class="cnpj-group">
              <form-group label="CNPJ:" :columns="12" :bold="true">
                <input class="form-input" v-mask="'NN.NNN.NNN/NNNN-NN'" v-model="cnpj" placeholder="CNPJ da conta">
                <small class="form-help">Utilizado para faturamento dos pedidos da conta no ERP. Vazio remove o CNPJ.</small>
              </form-group>
              <button class="btn btn--info" @click="saveCnpj" :disabled="savingCnpj">Salvar</button>
            </div>
          </panel>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <panel title="Autenticação">
            <div slot="header-right">
              <button class="hint hint--left btn" @click="refreshToken" data-label="Renovar token"><i class="icon-sync icon-loop2"></i></button>
            </div>
            <span class="ds-block"><strong>Token de acesso:</strong> {{ shopeeAccount.accessToken | attribute }}</span>
            <span class="ds-block"><strong>Token de renovação:</strong> {{ shopeeAccount.refreshToken | attribute }}</span>
            <span class="ds-block"><strong>Data de expiração:</strong> {{ shopeeAccount.expirationDate.replace('.000Z', '') | moment('DD/MM/YYYY HH:mm') }}</span>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import ModuleLogo from '@/components/template/ModuleLogo'
  import notifier from '@/notifier'
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      identifier: {
        type: String,
        required: false
      }
    },
    data: () => ({
      shopeeAccount: {},
      cnpj: '',
      savingCnpj: false,
      loading: true
    }),
    async mounted () {
      if (!this.account) {
        await this.fetchAccounts({})
      }

      this.loading = false
    },
    methods: {
      ...mapActions('shopeeAccounts', [
        'fetchAccounts',
        'setAccount'
      ]),
      isActive () {
        return {
          'success': this.shopeeAccount.active,
          'error': !this.shopeeAccount.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'shopee.accounts.active.label'
        }
        return 'shopee.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`marketplace/shopee/accounts/` + this.shopeeAccount.shopId)
      },
      async refreshToken () {
        try {
          const refreshedAccount = (await api.shopee.refreshToken(this.shopeeAccount.shopId))

          this.shopeeAccount = refreshedAccount
          this.setAccount(refreshedAccount)

          notifier.success(`Token da conta renovado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na renovação do token da conta.', 'Erro')
        }
      },
      async changeStatus (status) {
        if (this.shopeeAccount.active === status) {
          return false
        }

        try {
          await api.shopee.updateAccountStatus(this.shopeeAccount.shopId, status)

          this.shopeeAccount.active = status

          notifier.success(`Status da conta alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      },
      maskCnpj (cnpj) {
        if (!cnpj) {
          return ''
        }
        return cnpj.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})$/, '$1.$2.$3/$4-$5')
      },
      async saveCnpj () {
        this.savingCnpj = true

        try {
          const { account, updatedOrders } = await api.shopee.updateCnpj(this.shopeeAccount.shopId, this.cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase())

          this.shopeeAccount = account

          this.setAccount(account)

          this.savingCnpj = false

          notifier.success(`CNPJ salvo com sucesso. ${updatedOrders} pedido(s) atualizado(s).`, 'Sucesso')
        } catch (error) {
          this.savingCnpj = false

          notifier.error('Erro ao salvar o CNPJ da conta.', 'Erro')
        }
      }
    },
    watch: {
      'shopeeAccount.cnpj' (cnpj) {
        this.cnpj = this.maskCnpj(cnpj)
      }
    },
    computed: {
      ...mapGetters('shopeeAccounts', [
        'getAccount'
      ]),
      async account () {
        this.shopeeAccount = await api.shopee.getAccountByShopId(this.identifier)
        return this.shopeeAccount
      }
    },
    components: {
      Loader,
      PageTitle,
      ModuleLogo,
      Panel,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center
    padding: 30px 0

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

    .no-photo
      font-size: 150px
      color: darkgrey

  .cnpj-group
    margin-top: 16px

    .form-group
      max-width: 400px
      padding-left: 0

    .btn
      margin-top: 8px
</style>



// WEBPACK FOOTER //
// Edit.vue?88ec27f6